"use client"
import {
  Message_DefaultProp_delay_ms_should_be_greater_than_0,
  SuspensiveError
} from "./chunk-NF2UFYHD.js";
import {
  DelayDefaultPropsContext,
  SuspenseDefaultPropsContext
} from "./chunk-PJ6VIZI5.js";

// src/DefaultProps.tsx
import { jsx } from "react/jsx-runtime";
var DefaultProps = class {
  constructor(defaultProps = {}) {
    var _a;
    if (process.env.NODE_ENV === "development" && typeof ((_a = defaultProps.Delay) == null ? void 0 : _a.ms) === "number") {
      SuspensiveError.assert(defaultProps.Delay.ms > 0, Message_DefaultProp_delay_ms_should_be_greater_than_0);
    }
    this.Suspense = defaultProps.Suspense;
    this.Delay = defaultProps.Delay;
  }
};
var DefaultPropsProvider = ({ defaultProps, children }) => {
  var _a, _b;
  return /* @__PURE__ */ jsx(DelayDefaultPropsContext.Provider, { value: (_a = defaultProps.Delay) != null ? _a : {}, children: /* @__PURE__ */ jsx(SuspenseDefaultPropsContext.Provider, { value: (_b = defaultProps.Suspense) != null ? _b : {}, children }) });
};

export {
  DefaultProps,
  DefaultPropsProvider
};
//# sourceMappingURL=chunk-WUD4U6IE.js.map